export const TOKEN_KEY = 'token'
export const TOKEN_EXPIRATION_KEY = 'tokenExpiration'
export const REGION = 'region'
export const REGION_ACEPT = 'regionAccept'
export const USER = 'user'
export const IS_LOGIN_SSO = 'isLoginSSO'
// export const VALID_IMAGE = '?sp=r&st=2022-12-06T16:32:46Z&se=2023-12-07T00:32:46Z&spr=https&sv=2021-06-08&sr=c&sig=izAnhRtos9EO61CURspF0vPvpis7vs4LNR9DhkNUHa8%3D'